<template>
  <div class="flex items-center justify-center">
    <button v-if="!props.hidden" class="h-8 w-8 md:h-10 md:w-10" type="button" :disabled="props.disabled" @click="() => onClickDate(props.calendarDay)">
      <DateNoIcon :data-testid="`calendar-date-${props.calendarDay}`" :day="props.calendarDay" :disabled="props.disabled" :is-selected="props.isSelected" />
    </button>
  </div>
</template>

<script setup lang="ts">
import DateNoIcon from '@/components/molecules/wabunka/DateNoIcon/DateNoIcon.vue';

interface Props {
  isSelected: boolean;
  calendarDay: string;
  disabled: boolean;
  hidden: boolean;
  onClickDate: (day: string) => void;
}

const props = defineProps<Props>();
</script>
